import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { READING_LOCATION_DUPLICATE_ERROR } from '../common/constants';
import { BlobService } from '../common/services/blob.service';

export interface IErrorResponse {
    Message: string;
    ModelState: {};
    error_description: string;
    ExceptionMessage: string;
    error: string;
}

export class HttpService {
    public static $inject = ['$http', '$q', 'blobService', '$translate'];

    constructor(
        private $http: ng.IHttpService,
        private $q: ng.IQService,
        private blobService: BlobService,
        private $translate: angular.translate.ITranslateService
    ) { }

    public get<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<T> {
        return this.$http.get<T>(url, config).then(this.thenHandler).catch(this.catchHandler) as ng.IPromise<T>;
    }

    public getAllResponse<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<ng.IHttpResponse<T>> {
        return this.$http.get<T>(url, config).then(this.thenHandlerAllResponse).catch(this.catchHandler) as ng.IPromise<ng.IHttpResponse<T>>;
    }

    public delete<T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<T> {
        return this.$http.delete<T>(url, config).then(this.thenHandler).catch(this.catchHandler) as ng.IPromise<T>;
    }

    public post = <T>(url: string, data: any, config?: ng.IRequestShortcutConfig): ng.IPromise<T> => {
        return this.$http.post<T>(url, data, config).then(this.thenHandler).catch(this.catchHandler) as ng.IPromise<T>;
    }

    public put = <T>(url: string, data: any, config?: ng.IRequestShortcutConfig): ng.IPromise<T> => {
        return this.$http.put<T>(url, data, config).then(this.thenHandler).catch(this.catchHandler) as ng.IPromise<T>;
    }

    public patch = <T>(url: string, data: any, config?: ng.IRequestShortcutConfig): ng.IPromise<T> => {
        return this.$http.patch<T>(url, data, config).then(this.thenHandler).catch(this.catchHandler) as ng.IPromise<T>;
    }

    public postFile<T>(url: string, data: string): ng.IPromise<T> {
        return this.sendFile<T>(this.post, url, data);
    }

    public putFile<T>(url: string, data: string): ng.IPromise<T> {
        return this.sendFile<T>(this.put, url, data);
    }

    public decodeError = (response: ng.IHttpResponse<IErrorResponse>) : string => {
        let message;
        if (response.status === 400 || response.status === 401) {
            if (response.data.Message) {
                message = response.data.Message;

                if (response.data.ModelState) {
                    for (const key in response.data.ModelState) {
                        if (response.data.ModelState.hasOwnProperty(key)) {
                            response.data.ModelState[key].forEach((error: string) => message += '\r\n' + error);
                        }
                    }
                }
            } else if (response.data.error === 'account_blocked') {
                message = response.data;
            } else if (response.data.error_description) {
                message = response.data.error_description;
            } else if (response.data instanceof Array && response.data.length > 0) {
                if (response.data.length === 1) {
                    message = response.data[0].Key === READING_LOCATION_DUPLICATE_ERROR ? response.data[0].Key : this.$translate.instant(response.data[0].Key);
                }
                if (!message || (message === response.data[0].Key && response.data[0].Key !== READING_LOCATION_DUPLICATE_ERROR)) {
                    message = response.data[0].Errors.join('\r\n');
                }
            } else if (response.statusText) {
                message = response.statusText;
            } else {
                message = this.$translate.instant('internal_error_default_text');
            }
        } else if (response.status === 403) {
            if (response.data.ExceptionMessage) {
                message = response.data.ExceptionMessage;
            } else {
                message = this.$translate.instant('forbidden_error_default_text');
            }
        } else if (response.status === 404) {
            if (response.data.ExceptionMessage) {
                message = response.data.ExceptionMessage;
            } else {
                message = this.$translate.instant('not_found_error_default_text');
            }
        }
        return message;
    }

    private sendFile<T>(send: (url: string, data: any, config?: ng.IRequestShortcutConfig) => ng.IPromise<T>, url: string, data: string) {
        const blob = this.blobService.dataUriToBlob(data);
        const fd = new FormData();
        fd.append('image', blob);
        return send(url, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    }

    private thenHandlerAllResponse<T>(response: ng.IHttpResponse<T>): ng.IHttpResponse<T> {
        return response;
    }

    private thenHandler<T>(response: ng.IHttpResponse<T>): T {
        return response.data;
    }

    private catchHandler = <T>(response: ng.IHttpResponse<IErrorResponse>): (ng.IPromise<T> | string) => {
        if (response.status === -1) {
            return 'cancel';
        }

        const message = this.decodeError(response);
        return this.$q.reject(message);
    }
}

angular.module('app.common').service('http', HttpService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/api/http.service.ts